export default function SectionContainer({ children }) {
  return <div className="mx-auto flex max-w-4xl flex-col xl:max-w-6xl">{children}</div>;
}
